import React, { useEffect, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  Autocomplete,
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Log, sendDataWithPost, getEntityFilterConditions } from "../../services/services";
import { showSuccessMsg } from "../../utils/toast";
import { LoadingButton } from "@mui/lab";
import { isJSON } from "../../utils/storageUtils";
import { capitalize } from "lodash";
import { linkTextStyle, styles } from "../../utils/styles";
import { handleOpenLink } from "../../utils/appUtils";

const trigger_payout_default = {
  ingestor: {
    date: null,
    count: 0,
  },
  reconciliation: {
    date: null,
    count: 0,
  },
  settlement: {
    date: null,
    count: 0,
  },
  report: {
    date: null,
    count: 0,
  },
};

const TRIGGER_LIMIT = 3;

const matchedTitles = [
  "ingestor acquirer",
  "reconciliation",
  "settlement",
  "report",
  "bank report",
  "merchant report"
];

const TriggerManual = ({ title, url, isConsolidated }) => {
  const [date, setDate] = useState(new Date());
  const [acquirer, setAcquirer] = useState("");
  const [source, setSource] = useState("transaction");
  const [sourceReport, setSourceReport] = useState("ingest_gw2");
  const [dataSource, setDataSource] = useState({
    "bank report": "",
    "merchant report": "",
  });
  const [subTotal, setSubtotal] = useState(true);
  const [gst, setGst] = useState(false);
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialogConfirmTrigger, setOpenConfirmTriggerDialog] =
    useState(false);
  const [openTriggerLimitDialog, setOpenTriggerLimitDialog] = useState(false);

  // New states for enhancement

  const [triggerType, setTriggerType] = useState("manual");
  const [merchantList, setMerchantList] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState([]);
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  // Fetch merchant list from API
  useEffect(() => {
    //  dmmy function to avoid setLoaded error
    const dummySetLoaded = () => { };
    getEntityFilterConditions(setMerchantList, dummySetLoaded);
  }, []);

  useEffect(() => {
    const m = moment(date);
    const isValidDate = m.isValid();
    if (!isValidDate && !isError) setIsError(true);
    if (isValidDate && isError) setIsError(false);
    if (m.isAfter(new Date())) setIsError(true);
  }, [date]);

  const areTimesAtLeastOneHourApart = (time1, time2) => {
    // Parse the time strings into moment objects
    const momentTime1 = moment(time1);
    const momentTime2 = moment(time2);

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = Math.abs(momentTime1.diff(momentTime2));

    // Convert the difference to hours
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

    // Check if the difference is at least 1 hour
    return differenceInHours >= 1;
  };

  const onSubmit = async () => {
    if (isError) return;
    handleCloseConfirmTriggerDialog();

    // const trigger_payout_storage = localStorage.getItem("trigger_payout");
    // let trigger_payout = {};

    // if (isJSON(trigger_payout_storage)) {
    //   trigger_payout = { ...JSON.parse(trigger_payout_storage) };
    // } else {
    //   trigger_payout = { ...trigger_payout_default };
    // }

    // const count_trigger_limit = trigger_payout[title].count >= TRIGGER_LIMIT;
    // const trigger_date = moment(trigger_payout[title].date);

    // if (count_trigger_limit) {
    //   const now = new Date();
    //   if (trigger_date.isValid() && !areTimesAtLeastOneHourApart(trigger_date, now)) {
    //     handleOpenTriggerLimitDialog(true);
    //     return;
    //   }
    //   trigger_payout = {
    //       ...trigger_payout,
    //       [title]: { date: null, count: 0 }
    //   };
    // }

    const formatDate = moment(date).format("YYYY-MM-DD");
    let payload = {};

    if (title === "monthly report") {
      payload = {
        report_type: "monthly_report",
        trigger_date: date ? moment(date).format("YYYY-MM-01") : null,
      };
    } else if (isConsolidated) {
      payload = {
        is_consolidated: true,
        trigger_date: date ? moment(date).format("YYYY-MM-DD") : null,
      };
    } else if (title === "merchant report") {
      if (triggerType === "specialrequest") {
        payload = {
          trigger_type: "SpecialRequest",
          from_date: dateFrom ? moment(dateFrom).format("YYYY-MM-DD") : null,
          to_date: dateTo ? moment(dateTo).format("YYYY-MM-DD") : null,
          merchant_ids: selectedMerchant.length > 0
            ? selectedMerchant.map(m => m.merchant_id)
            : null,
        };
      } else {
        payload = {
          trigger_type: "Manual",
          trigger_date: date ? moment(date).format("YYYY-MM-DD") : null,
          source: dataSource[title],
          acquirer,
          has_gst: gst,
          merchant_ids: selectedMerchant.length > 0
            ? selectedMerchant.map(m => m.merchant_id)
            : null,
        };
      }
    } else {

      payload = {
        trigger_date: date ? moment(date).format("YYYY-MM-DD") : null,
        acquirer,
        ...((title === "ingestor gateway" || title === "ingestor gateway_3") && { source }),
        ...(title === "report" && {
          has_subtotal: subTotal,
          has_gst: gst,
          source: sourceReport,
        }),
        ...(title === "bank report" && {
          has_gst: gst,
          source: dataSource[title],
        }),
      };
    }

    setLoading(true);
    Log.info(`Click button [Submit] - Trigger ${title} manual`, payload);
    await sendDataWithPost(url, payload, () => {
      showSuccessMsg(`Trigger completed`);
      // localStorage.setItem(
      //   "trigger_payout",
      //   JSON.stringify({
      //     ...trigger_payout,
      //     [title]: {
      //       date: !trigger_payout[title].date
      //         ? new Date()
      //         : trigger_payout[title].date,
      //       count: trigger_payout[title].count + 1,
      //     },
      //   })
      // );
    });
    setLoading(false);
  };

  const handleCloseConfirmTriggerDialog = () => {
    setOpenConfirmTriggerDialog(false);
  };

  const handleOpenConfirmTriggerDialog = () => {
    setOpenConfirmTriggerDialog(true);
  };

  const handleCloseTriggerLimitDialog = () => {
    setOpenTriggerLimitDialog(false);
  };

  const handleOpenTriggerLimitDialog = () => {
    setOpenTriggerLimitDialog(true);
  };

  const getReportSourceOptions = () => {
    const baseOptions = [
      { value: "ingest_gw2", label: "Non Reconciled" },
      { value: "settlement", label: "Reconciled" }
    ];

    if (acquirer === "fiuu") {
      return baseOptions.filter(option => option.value !== "ingest_gw2");
    }
    return baseOptions;
  };

  const getBankMerchantReportSourceOptions = () => {
    const baseOptions = [
      { value: "ingest_data", label: "Non Reconciled" },
      { value: "settlement_data", label: "Reconciled" }
    ];

    if (acquirer === "fiuu") {
      return baseOptions.filter(option => option.value !== "ingest_data");
    }

    return baseOptions;
  };

  const menuItems =
    title === "ingestor gateway_3"
      ? [
          { id: "alipay", name: "Alipay" },
          { id: "allinpay", name: "Allinpay" },
          { id: "atome", name: "Atome" },
          { id: "dash", name: "Dash" },
          { id: "dci", name: "DCI" },
          { id: "dcs", name: "DCS" },
          { id: "fiuu", name: "Fiuu" },
          { id: "fomopay", name: "FOMOPay" },
          { id: "grabpay", name: "GrabPay" },
          { id: "liquidnet", name: "Liquid" },
          { id: "paynow", name: "PayNow - SCB" },
          { id: "shopee", name: "ShopeePay" },
          { id: "wechat", name: "WeChat" }
        ]
      : [
        { id: "paynow", name: "PayNow - SCB" },
        { id: "atome", name: "Atome" },
        { id: "alipay", name: "Alipay" },
        { id: "wechat", name: "WeChat" },
        { id: "shopee", name: title === "ingestor acquirer" ? "ShopeePay SG" : "ShopeePay" },
        ...(title === "ingestor acquirer" ? [{ id: "shopee_th", name: "ShopeePay TH" }] : []),
        { id: "dash", name: "Dash" },
        { id: "gp", name: "GP" },
        { id: "grabpay", name: "GrabPay" },
        { id: "dcs", name: "DCS" },
        ...(title !== "ingestor acquirer"
          ? [{ id: "dci", name: "DCI" }]
          : []),
        ...(title !== "ingestor gateway"
          ? [{ id: "liquidnet", name: "Liquid" }]
          : []),
        ...(matchedTitles.includes(title) ? [{ id: "fiuu", name: "Fiuu" }] : []),
        { id: "fomopay", name: "FOMOPay" },
        { id: "allinpay", name: "Allinpay" },
      ].sort((a, b) => a.name.localeCompare(b.name));

  const formattedItems = menuItems.map((item) => ({
    id: item.id,
    label: item.name,
  }));

  return (
    <>
      <Box sx={{ width: 250 }}>
        {title === "merchant report" && !isConsolidated && (
          <>
            {/* Report Type Dropdown */}
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel>Trigger Type</InputLabel>
              <Select
                value={triggerType}
                onChange={(e) => setTriggerType(e.target.value)}
                label="Trigger Type"
              >
                <MenuItem value="manual">Manual</MenuItem>
                <MenuItem value="specialrequest">Special Request</MenuItem>
              </Select>
            </FormControl>

            {/* From/To Date Pickers cho Special Request */}
            {triggerType === "specialrequest" && (
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="From Date"
                  value={dateFrom}
                  onChange={(newValue) => {
                    setDateFrom(newValue);
                    if (dateTo && moment(newValue).isAfter(dateTo)) {
                      setDateTo(newValue);
                    }
                  }}
                  disableFuture
                  inputFormat="YYYY/MM/DD"
                  renderInput={(params) => (
                    <TextField {...params} fullWidth sx={{ my: 2 }} />
                  )}
                />

                <DatePicker
                  label="To Date"
                  value={dateTo}
                  minDate={dateFrom || undefined} // constrains to date >= from date
                  onChange={(newValue) => setDateTo(newValue)}
                  disableFuture
                  inputFormat="YYYY/MM/DD"
                  renderInput={(params) => (
                    <TextField {...params} fullWidth sx={{ my: 2 }} />
                  )}
                />
              </LocalizationProvider>
            )}
          </>
        )}
        {triggerType !== "specialrequest" && (
          <>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                label={title === "monthly report" ? "Pick a month" : "Pick a time"}
                disableFuture
                inputFormat={title === "monthly report" ? "YYYY/MM" : "YYYY/MM/DD"}
                views={title === "monthly report" ? ["year", "month"] : ["year", "month", "day"]}
                value={date}
                disabled={loading}
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                renderInput={(params) => {
                  const { error } = params;
                  return (
                    <TextField
                      {...params}
                      error={error || !date}
                      fullWidth
                      sx={{ my: 2 }}
                    />
                  );
                }}
              />
            </LocalizationProvider>

            {!isConsolidated && (
            <FormControl fullWidth sx={{ my: 2 }}>
              <Autocomplete
                options={formattedItems}
                renderOption={(props, option) => (
                  <li {...props} key={option.id}>
                    {option.label}
                  </li>
                )}
                onChange={(e, newValue) => {
                  setAcquirer(newValue?.id);

                  if (newValue?.id === "fiuu") {
                    const updates = {};

                    if (sourceReport === "ingest_gw2") {
                      setSourceReport("settlement");
                    }

                    Object.keys(dataSource).forEach((key) => {
                      if (dataSource[key] === "ingest_data") {
                        updates[key] = "";
                      }
                    });

                    if (Object.keys(updates).length > 0) {
                      setDataSource((prev) => ({ ...prev, ...updates }));
                    }
                  }
                }}
                fullWidth
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Acquirer"
                  />
                )}
                isOptionEqualToValue={(option) =>
                  option.id === acquirer
                }
              />
            </FormControl>
            )}
          </>
        )}

        {
          (title === "bank report" || title === "merchant report") && !isConsolidated && (
            <>
              {triggerType !== "specialrequest" && (
                <>
                  <FormControl fullWidth sx={{ my: 2 }}>
                    <InputLabel>Source</InputLabel>
                    <Select
                      value={dataSource[title]}
                      label="Source"
                      onChange={(e) => {
                        setDataSource(prev => ({ ...prev, [title]: e.target.value }));
                      }}
                    >
                      {getBankMerchantReportSourceOptions().map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={gst}
                          onChange={(e) => setGst(e.target.checked)}
                        />
                      }
                      label="Has GST"
                    />
                  </FormControl>
                </>
              )}
            </>
          )}
        {title === "merchant report" && !isConsolidated && (
          <>
            {/* Merchant Dropdown (multiple) */}
            <FormControl fullWidth sx={{ my: 2 }}>
              <Autocomplete
                disableCloseOnSelect
                multiple
                options={
                  (merchantList?.merchant_payout || [])
                    .filter(
                      (item) =>
                        item &&
                        item.merchant_id &&
                        item.merchant_name &&
                        !selectedMerchant.some(
                          (selected) => selected.merchant_id === item.merchant_id
                        )
                    )
                    .map((item) => ({
                      merchant_id: item.merchant_id,
                      merchant_name: item.merchant_name,
                      label: item.merchant_name,
                    }))
                }
                getOptionLabel={(option) => option.merchant_name}
                onChange={(e, newValue) => setSelectedMerchant(newValue)}
                value={selectedMerchant}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Merchant(s)"
                    placeholder="Select Merchant"
                  />
                )}
              />
            </FormControl>
          </>
        )}
        {(title === "ingestor gateway" || title === "ingestor gateway_3") && (
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel>Source</InputLabel>
            <Select
              value={source}
              label="Source"
              onChange={(e) => {
                setSource(e.target.value);
              }}
            >
              <MenuItem value="transaction">Transaction</MenuItem>
              <MenuItem value="merchant">Merchant</MenuItem>
              <MenuItem value="merchant_payout_info">Merchant Payout Info</MenuItem>
              {title === "ingestor gateway_3" ? (
                <MenuItem value="business_entity">Business Entity</MenuItem>
              ) : (
                <MenuItem value="merchant_payout_info_master_file">Master File</MenuItem>
              )}
            </Select>
          </FormControl>
        )}

        {title === "report" && !isConsolidated && (
          <>
            <FormControl fullWidth sx={{ my: 2 }}>
              <InputLabel>Source</InputLabel>
              <Select
                value={sourceReport}
                label="Source"
                onChange={(e) => {
                  setSourceReport(e.target.value);
                }}
              >
                {getReportSourceOptions().map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={subTotal}
                    onChange={(e) => setSubtotal(e.target.checked)}
                  />
                }
                label="Has Subtotal"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={gst}
                    onChange={(e) => setGst(e.target.checked)}
                  />
                }
                label="Has GST"
              />
            </FormControl>
          </>
        )}
      </Box>
      <Box sx={{ mt: 5 }}>
        <LoadingButton
          variant="contained"
          loading={loading}
          disabled={isError}
          onClick={handleOpenConfirmTriggerDialog}
          sx={{ ...styles.customButton }}
        >
          Submit
        </LoadingButton>

      </Box>

      {title === "report" && !isConsolidated && (
        <Box sx={{ mt: 3 }}>
          <Typography
            component="span"
            sx={{ ...linkTextStyle }}
            onClick={() =>
              handleOpenLink(process.env.REACT_APP_PAYOUT_REPORT_FOLDER)
            }
          >
            Report Folder
          </Typography>
        </Box>
      )}




      <Dialog
        open={openDialogConfirmTrigger}
        onClose={handleCloseConfirmTriggerDialog}
      >
        <DialogTitle>
          {`Manual trigger will reload data of selected date ${moment(
            date
          ).format(title === "monthly report" ? "YYYY-MM" : "YYYY-MM-DD")}. Are you sure you want to trigger?`}
        </DialogTitle>
        <DialogActions>
          <LoadingButton
            variant="outlined"
            onClick={handleCloseConfirmTriggerDialog}
          >
            Cancel
          </LoadingButton>
          <LoadingButton variant="contained" color="info" onClick={onSubmit} sx={{ ...styles.customButton }}>
            Submit
          </LoadingButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openTriggerLimitDialog}
        onClose={handleCloseTriggerLimitDialog}
      >
        <DialogTitle>
          {`You have triggered ${capitalize(
            title
          )} 3 times, please trigger again after 1 hour.`}
        </DialogTitle>
        <DialogActions>
          <LoadingButton
            variant="contained"
            onClick={handleCloseTriggerLimitDialog}
          >
            Cancel
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TriggerManual;
